/**
 *
 * @module searchQuery
 *
 */

import Check from 'check-types';
import Exception from './../../services/exception/entry';
import GraphQlQuery from './../graphQlQuery';
import ContentQuery from './../contentQuery';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class SearchQuery
 *
 */
export default class SearchQuery extends ContentQuery {

    /**
     *
     * @param {GraphQlQuery} query
     *
     */
    constructor(query) {

        const errorMessage = {
            ctor: 'SearchQuery(query)',
            get query() {
                return `${this.ctor} needs graphQlQuery instance`;
            }
        };

        instanceStrict(query, GraphQlQuery, errorMessage.query, InvalidArgumentException);

        super('search', query);

    }

}



// WEBPACK FOOTER //
// ./src/content/search/searchQuery.js